/* eslint-disable */
import { Request } from "@collectivehealth/cog";

type Url = {
  url: string;
};

export type Asset = {
  key: string;
  value: Url;
};

export type Response = {
  data: Array<Asset>;
};

export default class AssetService {
  static getAssetsForCollection(collectionCode: string): Promise<Response> {
    return Request.req({
      url: "/api/v1/asset/assets",
      method: "GET",
      params: {
        collectionCode
      }
    });
  }
}
